// Conversion event tracking. Forwards to GA4 / Meta Pixel / PostHog when present.
export const track = (event, props = {}) => {
  try {
    if (typeof window !== "undefined") {
      if (typeof window.gtag === "function") window.gtag("event", event, props);
      if (typeof window.fbq === "function") window.fbq("trackCustom", event, props);
      if (window.posthog && typeof window.posthog.capture === "function") window.posthog.capture(event, props);
      console.info(`[track] ${event}`, props);
    }
  } catch {
    /* tracking must never break the page */
  }
};
